module.exports = __webpack_public_path__ + "static/img/9.5122499.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/loading/img/9.png
// module id = tUi2
// module chunks = 0